import { MutableRefObject, useState } from "react";
import drawerStyles from "../../styles/drawer.module.css";
import EmployeePreferencesTab from "./preferencesTab/EmployeePreferencesTab";
import EmployeeSettingsTab from "./EmployeeSettingsTab";

type EmployeeDrawerTabsType = "EMPLOYEE" | "PREFERENCES";
type EmployeeDrawerTabObject = { title: string; type: EmployeeDrawerTabsType };

const EmployeeDrawerContent = ({
  onEmployeeUnsavedEdit,
  onDeleteWorkTimeRequest,
  worktimeSaveRef,
  transportSaveRef,
}: {
  onEmployeeUnsavedEdit: (hasChanges: boolean) => void;
  onDeleteWorkTimeRequest: () => void;
  worktimeSaveRef?: MutableRefObject<(() => Promise<void>) | null>;
  transportSaveRef?: MutableRefObject<(() => Promise<void>) | null>;
}) => {
  const [selected, setSelected] = useState<EmployeeDrawerTabsType>("EMPLOYEE");

  // NOTE: The tab bar is currently edited out, since only the worktime 
  // and transport type settings are ready.
  // When the preferences settings are ready, the tab bar should be added back.

/*   const tabBarValues: EmployeeDrawerTabObject[] = [
    { title: labels.employeeSettings, type: "EMPLOYEE" },
    { title: labels.citizenPreferences, type: "PREFERENCES" },
  ]; */

  return (
    <div className={drawerStyles.drawerContent}>
{/*       <ColouredRoundWrapper bgColor="var(--col-surface-secondary)" width="100%">
        {tabBarValues.map((tab, index) => (
          <TabButton
            key={index}
            fullWidth
            tabTitle={
              tab.type === "EMPLOYEE"
                ? labels.employeeSettings
                : labels.citizenPreferences
            }
            onClick={() => setSelected(tab.type)}
            selected={
              selected === "EMPLOYEE"
                ? labels.employeeSettings
                : labels.citizenPreferences
            }
          />
        ))}
      </ColouredRoundWrapper> */}

      {selected === "EMPLOYEE" && (
        <EmployeeSettingsTab
          onEmployeeUnsavedEdit={onEmployeeUnsavedEdit}
          onDeleteWorkTimeRequest={onDeleteWorkTimeRequest}
          worktimeSaveRef={worktimeSaveRef}
          transportSaveRef={transportSaveRef}
        />
      )}
      {selected === "PREFERENCES" && <EmployeePreferencesTab />}
    </div>
  );
};

export default EmployeeDrawerContent;
